"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _firebaseAdmin = _interopRequireDefault(require("firebase-admin"));

var _serviceAccount = _interopRequireDefault(require("../service-account.json"));

var _Guard = _interopRequireDefault(require("./Guard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { expect } from 'chai';

/**
 * Prepare a model for transport into firestore
 * @param {Object} model convert object from a es6 class into a simple POJO (POESO?)
 */
function prepareModelForTransport(model) {
  return JSON.parse(JSON.stringify(model));
}
/**
 * Wrapper for all access to firestore
 */


class FirestoreConnection {
  /**
   * Create a new instance of firestore with a service account permissions
   * @param {Object} serviceAccount credentials for accessing firestore (null to use default)
   * @param {String} name name of this instance or @{null} if you want the default connection
   * @param {String} collectionName name of the collection if not the default value
   * @returns {FirestoreConnection} returns self so you can chain this to the constructor
   */
  constructor(serviceAccount, name, collectionName) {
    this.serviceAccount = serviceAccount || _serviceAccount.default;
    this.collection = collectionName || 'environments';
    this.name = name; // post-guards

    _Guard.default.requiresNotNull(this.collection, 'this.collection');

    _Guard.default.requiresNotNull(this.serviceAccount, 'this.serviceAccount');
  }
  /**
   * Call this before making any requests, it does basic checks against the service account
   * credentials you passed into the ctor and builds the database instance.
   * @returns {FirestoreConnection}
   */


  connect() {
    const app = _firebaseAdmin.default.apps.length ? _firebaseAdmin.default.apps[0] : _firebaseAdmin.default.initializeApp({
      credential: _firebaseAdmin.default.credential.cert(this.serviceAccount),
      databaseURL: `https://${this.serviceAccount.project_id}.firebaseio.com`
    }, this.name);
    this.db = _firebaseAdmin.default.firestore(app); // post-guards

    _Guard.default.requiresNotNull(this.db, 'this.db');

    return this;
  }
  /**
   * List all collections in the database
   * @returns {Promise} connect to this to list the connections.
   */


  listConnections() {
    _Guard.default.requiresNotNull(this.db, 'this.db');

    return this.db.getCollections();
  }
  /**
   * Save a model with a known id
   * @param {String} id the unique identifier for this object
   * @param {Object} model the model to set this document to
   * @returns {Promise} the callback from the set.
   */


  setObject(id, model) {
    _Guard.default.requiresNotNull(id, 'id');

    _Guard.default.requiresNotNull(model, 'model');

    _Guard.default.requiresNotNull(this.db, 'this.db');

    console.log('setting record with id', id);
    return this.db.collection(this.collection).doc(id).set(prepareModelForTransport(model));
  }
  /**
   * Similar to @{setObject} but without having an id (allow server to generate one).
   * @param {Object} model the model to save to the database
   * @returns {Promise} the callabck.
   */


  addObject(model) {
    _Guard.default.requiresNotNull(model, 'model');

    _Guard.default.requiresNotNull(this.db, 'this.db');

    console.log('setting record without id');
    return this.db.collection(this.collection).add(prepareModelForTransport(model));
  }
  /**
   * Grab a snapshot of the document with the @{id} supplied
   * @param {String} id the document's identifier
   * @returns {Promise<Object>} the callback with the model (or null if not found)
   */


  getObjectOnce(id) {
    _Guard.default.requiresNotNull(id, 'id');

    _Guard.default.requiresNotNull(this.db, 'this.db');

    console.log('getting record with id', id);
    return this.db.collection(this.collection).doc(id).get().then(d => d.exists ? d.data() : null);
  }
  /**
   * Monitor a document for changes
   * @param {String} id request id
   * @param {Function<FirebaseFirestore.DocumentSnapshot>} callback when a change has occurred
   * @param {String} [collection=environments] the collection to monitor
   * @param {Function<Error>} [onErrorCallback=null] error callback
   */


  monitorObject(id, callback, collection, onErrorCallback) {
    _Guard.default.requiresNotNull(id, 'id');

    _Guard.default.requiresNotNull(callback, 'callback');

    return this.db.collection(collection || this.collection).doc(id).onSnapshot(callback, onErrorCallback);
  }
  /**
   * Update (or insert) a field with a given @{value} using a "merge"
   * URI string.
   * @param {String} id the uid for the record to update
   * @param {*} value the value to set at the @{path} supplied
   * @returns {Promise} a callback when this has been updated (or failed trying)
   */


  mergeField(id, value) {
    _Guard.default.requiresNotNull(id, 'id');

    _Guard.default.requiresNotNull(value, 'value');

    _Guard.default.requiresNotNull(this.db, 'this.db');

    const valueToMerge = prepareModelForTransport(value);
    console.log('merging record with id', id, valueToMerge);
    return this.db.collection(this.collection).doc(id).set(valueToMerge, {
      merge: true
    });
  }
  /**
   * Delete the record
   * @param {String} id the identifier for the record to delete
   * @returns {Promise} callback when done
   */


  deleteObject(id) {
    _Guard.default.requiresNotNull(id, 'id');

    _Guard.default.requiresNotNull(this.db, 'this.db');

    console.log('deleting record with id', id);
    return this.db.collection(this.collection).doc(id).delete();
  }

}

exports.default = FirestoreConnection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vigilantapps/vipro-online-request-manager/dist/FirestoreConnection.js
// module id = x8Td
// module chunks = 0